<template>
  <page-content
    v-if="currentUser != null"
    :has-sticky-col-left="true"
    :has-left-col-small="true"
    :has-padd-right-normal="false"
    :has-padd-left-normal="false"
    :has-padd-right-on-act="false"
    :has-padd-left-on-act="false"
    :set-left-col-class="'is-narrow is-maxW300p is-minW300p is-margin-right-less is-marginless-right has-background-white is-border-right'"
    :has-left-col-collapse="true"
    :opened-col="true">
    <template slot="left-col-small">
      <div class="field is-marginless">
        <div class="control">
          <div class="has-flatpickr-responsive has-flatpickr-theme--s1 has-flatpickr-padding-h has-background-white-ter is-border-bottom is-padding-bottom-small">
            <flat-pickr
              :config="configDateMini"
              id="flatpickr"
              class="input is-hidden is-radiusless is-shadowless flatpickr-input is-noDecalPosTop"
              name="date"
              v-model="flatPickrDate"
              @on-change="goToDay"></flat-pickr>
          </div>
        </div>
      </div>
      <div>
        <div
          v-if="hasFilter"
          class="is-padding-left is-padding-top-xxsmall is-padding-bottom-xxsmall is-border-top has-background-annonce">
          <a
            class="has-text-white is-size-6"
            @click.prevent.stop="resetFilters">
            <span class="icon"><i class="fas fa-undo"></i></span>
            <span class="is-italic">Réinitialiser tous les filtres</span>
          </a>
        </div>
        <div class="is-padding-top-small is-padding-left is-padding-right">
          <r-label
            :label="'Filtrage par critères :'"
            :is-required="false"></r-label>
          <div class="field is-grouped">
            <div
              v-for="type in rdvTypeList"
              :key="type.value"
              class="control is-expanded">
              <input
                :id="type.value"
                v-model="filters.rdv_type"
                :value="type.label"
                name="typeRdv"
                :class="{'is-active' : filters.rdv_type.map(x=> x.value).includes(type.value)}"
                checked="checked"
                class="vadCheckradiocase is-primary is-fullwidth"
                type="checkbox"
                @change="updateSimpleFilter(); focus(`#${type.value}`)">
              <label :for="type.value">{{ type.label }}</label>
            </div>
          </div>
        </div>
        <div
          v-if="isAdmin || isManager"
          class="is-padding-left is-padding-right is-padding-top-small">
          <div class="control">
            <div
              @click="openUserSelection('author')"
              class="input">
              <div v-if="filters.author && filters.author.length">
                <span class="">Organisateurs ({{ filters.author.length }})</span>
              </div>
              <span
                v-else
                class="has-text-grey">Sélectionner organisateur</span>
            </div>
          </div>
        </div>
        <div class="is-padding-left is-padding-right is-padding-top-small">
          <div class="control">
            <div
              @click="openContactSelection()"
              class="input">
              <div v-if="filters.contact && filters.contact.length">
                <span class="">contacts ({{ filters.contact.length }})</span>
              </div>
              <span
                v-else
                class="has-text-grey">Rechercher contact</span>
            </div>
          </div>
        </div>
        <div
          v-if="isAdmin || isManager"
          class="is-padding-left is-padding-right is-padding-top-small">
          <div class="control">
            <div
              @click="openUserSelection('user')"
              class="input">
              <div v-if="filters.user && filters.user.length">
                <span class="">Participants ({{ filters.user.length }})</span>
              </div>
              <span
                v-else
                class="has-text-grey">Rechercher participant</span>
            </div>
          </div>
        </div>
        <div
          v-if="(isAdmin && isPromoteur) || currentUser.active_all_contact"
          class="field is-padding-left is-padding-right is-padding-top-small">
          <div class="control">
            <multiselect
              @input="updateSimpleFilter"
              @open="!programsFilter.length ? getAgenceByName() : null"
              :loading="loadingFilters === 'agence'"
              v-model="filters.agence"
              label="name"
              track-by="pk"
              class="multiselect--option-ico is-single_choice"
              open-direction="bottom"
              :multiple="true"
              :options="agencesFilter"
              :searchable="true"
              :close-on-select="false"
              :show-labels="false"
              :placeholder="''">
              <span slot="noResult">Oups! Aucune agence trouvée.</span>
              <span
                slot="placeholder"
                class="multiselect__placeholder">Agences</span>
              <span
                slot="selection"
                class="multiselect__placeholder"
                slot-scope="{ values }"
                v-if="values.length">
                <span>Agences ({{ values.length }})</span>
              </span>
              <span slot="noOptions">La liste est vide</span>
            </multiselect>
          </div>
        </div>
      </div>
    </template>

    <template>
      <filters-tags
        id="user-tag"
        :has-filter="hasFilter"
        :filters="filters"
        @reset="resetFilters"
        @update="updateFromTag($event)"></filters-tags>
      <div>
        <tabs
          class="has-background-white is-border-bottom"
          :niveau="1">
          <li :class="{'is-active' : panel === 'rdvs'}">
            <a
              @click="changeRoute('rdvs')"
              class="">
              <span class="">Rendez-vous ({{ calendarRdvProgramedActions }})</span>
            </a>
          </li>
          <li :class="{'is-active' : panel === 'reminders'}">
            <a
              @click="changeRoute('reminders')"
              class="">
              <span class="">Rappel ({{ calendarReminderProgramedActions }})</span>
            </a>
          </li>
          <li :class="{'is-active' : panel === 'options'}">
            <a
              @click="changeRoute('options')"
              class="">
              <span class="">Fin d'option ({{ calendarOptionProgramedActions }})</span>
            </a>
          </li>
        </tabs>
        <!-- <div class="is-padding-left is-padding-right is-padding-top-small is-padding-bottom-small is-marginless field is-grouped is-borderless">
          <label class="checkbox checkRadioIsHide is-padding-right-xsmall"
                v-for="s in qualifications"
                :for="'filter-'+s.value"
                :key="s.value"
                v-show="panel == 'rdvs'">
            <input type="checkbox" :id="'filter-'+s.value" v-model="fitlers.status" @click="qualificationSelected = s.value" :value="s.value">
            <span class="tag is-radiusless" :class="s.color">
              <span>{{s.label}}</span>
              <span class="icon"><i class="far" :class="s.value ? qualificationSelected === s.value ? 'fa-check-circle' : 'fa-circle' : 'fa-times-circle'"></i></span>
            </span>
          </label>
        </div> -->
        <div class="is-padding-left is-padding-right is-padding-top-small is-padding-bottom-small is-border-bottom">
          <div
            v-if="panel == 'rdvs'"
            class="field is-grouped">
            <p
              class="control"
              v-for="status in qualifications"
              :key="status.value">
              <label
                class="checkbox checkRadioIsHide"
                :for="status.value">
                <input
                  :id="status.value"
                  :name="status.label"
                  type="checkbox"
                  :value="status.value"
                  v-model="filters.status"
                  @click="updateSimpleFilter">
                <span
                  class="tag"
                  :class="status.color">
                  <span>{{ status.label }}</span><span class="icon"><i
                    class="far"
                    :class="filters.status.includes(status.value) ? 'fa-check-square' : 'fa-square'"></i></span>
                </span>
              </label>
            </p>
          </div>
        </div>
        <div
          class="bulmaCalendar is-fullContentHeight"
          style="min-height: 75vh">
          <div class="datetimepicker is-active is-fullwidth is-dayView is-cardless">
            <div class="datetimepicker-container">
              <div
                class="datepicker-body"
                @click.self="newCalendarAction()">
                <div
                  v-for="hour in hoursTab"
                  :key="hour"
                  class="datepicker-hourSep"
                  :data-time="hour">
                  <div
                    class="day-events "
                    v-if="eventByHour">
                    <template v-if="panel == 'rdvs'">
                      <calendar-rdv-items
                        v-for="rdv in eventByHour[hour]"
                        :key="rdv.pk"
                        :event="rdv"
                        @loadRdvs="loadRdvs"></calendar-rdv-items>
                    </template>
                    <template v-if="panel == 'reminders'">
                      <calendar-reminder-items
                        v-for="reminder in eventByHour[hour]"
                        :key="reminder.pk"
                        :event="reminder"
                        @loadReminders="loadReminders"></calendar-reminder-items>
                    </template>
                    <template v-if="panel == 'options'">
                      <calendar-option-items
                        v-for="option in eventByHour[hour]"
                        :key="option.pk"
                        :event="option"
                        @loadOptions="loadOptions"></calendar-option-items>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </page-content>
</template>

<script>
import { Calendar, Filter, Quickview, FilterGetter } from '@/mixins'
import moment from 'moment'
import { mapGetters } from 'vuex'

export default {
  name: 'CalendarDay',
  components: {
    CalendarRdvItems: () => import('@/components/calendar/dayView/CalendarRdvItems'),
    CalendarReminderItems: () => import('@/components/calendar/dayView/CalendarReminderItems'),
    CalendarOptionItems: () => import('@/components/calendar/dayView/CalendarOptionItems')
  },
  mixins: [Calendar, Filter, Quickview, FilterGetter],
  data () {
    return {
      loadDocuments: this.loadRdv
    }
  },
  computed: {
    ...mapGetters(['isAdmin', 'isManager', 'isPromoteur']),
    /**
       * current panel in route params
       * @returns {string}
       */
    panel () {
      return this.$route.params.panel
    },
    /**
       * Array with hours
       * @returns {array}
       */
    hoursTab () {
      let i = 0
      let hours = []
      for (i; i < 24; i++) {
        let hour = moment().hour(i)
        hour = moment(hour).format('HH')
        hours.push(hour + ':00')
      }
      return hours
    },
    /**
       * Event list by hours
       * @returns {object}
       */
    eventByHour () {
      let eventByDay
      if (this.panel === 'reminders') {
        eventByDay = this.remindersByDay
      } else if (this.panel === 'options') {
        eventByDay = this.optionsByDay
      } else {
        eventByDay = this.rdvsByDay
      }
      let eventHours = {}
      for (let hour of this.hoursTab) {
        eventHours[hour] = []
      }
      for (let event of eventByDay) {
        let d
        if (this.panel === 'options') {
          d = moment.utc(event.end_date, moment.ISO_8601)
        } else {
          d = moment.utc(event.date, moment.ISO_8601)
        }
        d = d.toDate()
        let hour = moment(d).format('HH')
        hour = hour + ':00'
        eventHours[hour].push(event)
      }
      return eventHours
    }
  },
  methods: {
    newCalendarAction () {
      this.$store.commit('setQuickview', { mode: 'NEW_CALENDAR_ACTION', params: { fromCalendarDate: this.flatPickrDate } })
    },
    /**
       * change route
       * @param {string} panel
       */
    async changeRoute (panel) {
      this.initCalendar = false
      let year = this.$route.params.year
      let month = this.$route.params.month
      let day = this.$route.params.day
      await this.$router.replace({ name: 'CalendarDay', params: { year, month, day, panel } })
      this.initCalendar = true
    }
  }
}
</script>
